import { Skeleton } from "@/components/ui/skeleton";

export default function TopupDetailCardSkeleton() {
  return (
    <div className="mt-4 flex flex-col gap-4">
      <Skeleton className="h-7 w-40 md:h-8" />
      <div className="rounded-2xl bg-card p-4 shadow-xl">
        <div className="grid grid-cols-1 items-center gap-4 md:grid-cols-4">
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-5 w-36" />
          </div>
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-5 w-24" />
          </div>
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-5 w-24" />
          </div>
          <div className="flex justify-start md:justify-end md:me-5">
            <Skeleton className="h-7 w-20 rounded-lg" />
          </div>
        </div>
      </div>
      <Skeleton className="h-7 w-36" />

      {[1, 2].map((item) => (
        <div
          key={item}
          className="rounded-2xl bg-card p-4 shadow-xl"
        >
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-5 w-40" />
            </div>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
              {[1, 2, 3, 4, 5].map((ticket) => (
                <div
                  key={ticket}
                  className="flex flex-col gap-2"
                >
                  <Skeleton className="h-4 w-20" />
                  <Skeleton className="h-9 w-12 md:h-10" />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}